export default function Footer() {
  return (
    <footer className="bg-[#1e3a5f] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <a href="https://phuotmy.com/" target="_blank" rel="noopener noreferrer" className="block mb-6 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/4e6899cadfb83a22fc80720bbcef0e10.png" 
                alt="Phượt Mỹ - Vui Khởi Nghĩ" 
                className="h-16 w-auto mb-4"
              />
              <h3 className="text-2xl font-bold mb-2">Phượt Mỹ</h3>
              <p className="text-gray-400">Vui Khởi Nghĩ</p>
            </a>
            <p className="text-gray-400 leading-relaxed">
              Chuyên tổ chức tour Mỹ chất lượng cao với 15+ năm kinh nghiệm. Roadtrip - Caravan - Trải nghiệm văn hóa bản địa.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Liên kết nhanh</h4>
            <ul className="space-y-2">
              <li><a href="#hero" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Trang chủ</a></li>
              <li><a href="#itinerary" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Lịch trình</a></li>
              <li><a href="#highlights" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Điểm nổi bật</a></li>
              <li><a href="#pricing" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Giá tour</a></li>
              <li><a href="#gallery" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Thư viện</a></li>
            </ul>
          </div>

          {/* Tours */}
          <div>
            <h4 className="text-lg font-bold mb-4">Tour Hawaii</h4>
            <ul className="space-y-2">
              <li><a href="#pricing" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Tour 2 Đảo</a></li>
              <li><a href="#pricing" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Tour 3 Đảo</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Dịch vụ</a></li>
              <li><a href="#conditions" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Điều kiện</a></li>
              <li><a href="#testimonials" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Đánh giá</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Liên hệ</h4>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-400">
                <i className="ri-phone-line text-xl mr-2 flex-shrink-0 mt-1"></i>
                <div>
                  <div className="text-white font-semibold">Hotline 24/7</div>
                  <div>VN: 0889992466</div>
                  <div>USA: +1 714 552 1068</div>
                </div>
              </li>
              <li className="flex items-start text-gray-400">
                <i className="ri-mail-line text-xl mr-2 flex-shrink-0 mt-1"></i>
                <div>
                  <div className="text-white font-semibold">Email</div>
                  <div>info@phuotmy.com</div>
                  <div>info@caravanusa.com</div>
                </div>
              </li>
              <li className="flex items-start text-gray-400">
                <i className="ri-chat-3-line text-xl mr-2 flex-shrink-0 mt-1"></i>
                <div>
                  <div className="text-white font-semibold">Zalo</div>
                  <div>0889992466</div>
                </div>
              </li>
              <li className="flex items-start text-gray-400">
                <i className="ri-map-pin-line text-xl mr-2 flex-shrink-0 mt-1"></i>
                <div>
                  <div className="text-white font-semibold">Văn phòng</div>
                  <div>Hà Nội - Việt Nam</div>
                  <div>California - Hoa Kỳ</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>&copy; 2026 Phượt Mỹ - Vui Khởi Nghĩ. All rights reserved. | <a href="https://phuotmy.com/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors cursor-pointer">Powered by Phượt Mỹ</a></p>
        </div>
      </div>
    </footer>
  );
}
